import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DocumentTypeFederalRegisterItems } from './documenttypefederalregisteritems';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumenttypefederalregisteritemsService {

  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }

  Get(): Observable<DocumentTypeFederalRegisterItems[]> {
    return this.httpClient.get<DocumentTypeFederalRegisterItems[]>(this.baseUrl + 'api/DocumentTypeFederalRegisterItemsApi')
  }
  GetActive(): Observable<DocumentTypeFederalRegisterItems[]> {
    return this.httpClient.get<DocumentTypeFederalRegisterItems[]>(this.baseUrl + 'api/DocumentTypeFederalRegisterItemsApi/GetActiveDocumentTypeFederalRegisterItems')
  }
  Post(documenttypefederalregisteritems: DocumentTypeFederalRegisterItems): Observable<any> {

    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeFederalRegisterItemsApi/add', documenttypefederalregisteritems, { headers: header, observe: 'response' })
  }
  Delete(documenttypefederalregisteritems: DocumentTypeFederalRegisterItems) {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post(this.baseUrl + 'api/DocumentTypeFederalRegisterItemsApi/activeordeactive', documenttypefederalregisteritems, { headers: header, observe: 'response' })
  }
  Put(documenttypefederalregisteritems: DocumentTypeFederalRegisterItems): Observable<any> {
    let header = new HttpHeaders();
    header = header.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put(this.baseUrl + 'api/DocumentTypeFederalRegisterItemsApi/Update', documenttypefederalregisteritems, { headers: header, observe: 'response' })
  }
}
